<div class="flex items-center gap-2">
  <app-button
    [disabled]="!canGoPrevious()"
    (clickEvent)="goToPrevious()"
    type="icon"
    [icon]="ICONS.caretLeft"
    [tooltip]="'common.previous' | translate" />

  <span class="text-text-secondary font-mono text-xs">
    {{ paginationConfig().currentPage }}/{{ paginationConfig().totalPages }}
  </span>

  <app-button
    [disabled]="!canGoNext()"
    (clickEvent)="goToNext()"
    type="icon"
    [icon]="ICONS.caretRight"
    [tooltip]="'common.next' | translate" />
</div>
